@if (location$ | async; as location) {
  <h3>{{ location.tag }}: {{ location.name }}</h3>
}
